import request from "../request";

export const getEvidenceOfLearningByLcIdAndLevelId = (
  curriculumId,
  studentId,
  lcId,
  levelId,
  data
) =>
  request
    .get(
      `/assessment/${curriculumId}/maestro/evidence-of-learning/student/${studentId}/learning-continuum/${lcId}/levelId/${levelId}`,
      data
    )
    .then((res) => res);

export const createEvidenceOfLearningByLcIdAndLevelId = (
  curriculumId,
  studentId,
  lcId,
  levelId,
  data
) =>
  request
    .post(
      `/assessment/${curriculumId}/maestro/evidence-of-learning/student/${studentId}/learning-continuum/${lcId}/levelId/${levelId}`,
      data
    )
    .then((res) => res);

export const deleteEvidenceOfLearning = (curriculumId, studentId, id) =>
  request
    .delete(
      `/assessment/${curriculumId}/maestro/evidence-of-learning/student/${studentId}/${id}`
    )
    .then((res) => res);

export const addCommentToEvidenceOfLearning = (
  curriculumId,
  studentId,
  id,
  data
) =>
  request
    .post(
      `/assessment/${curriculumId}/maestro/evidence-of-learning/student/${studentId}/${id}/comment`,
      data
    )
    .then((res) => res);

export const updateCommentToEvidenceOfLearning = (
  curriculumId,
  studentId,
  id,
  commentId,
  data
) =>
  request
    .put(
      `/assessment/${curriculumId}/maestro/evidence-of-learning/student/${studentId}/${id}/comment/${commentId}`,
      data
    )
    .then((res) => res);

export const deleteCommentToEvidenceOfLearning = (
  curriculumId,
  studentId,
  id,
  commentId
) =>
  request
    .delete(
      `/assessment/${curriculumId}/maestro/evidence-of-learning/student/${studentId}/${id}/comment/${commentId}`
    )
    .then((res) => res);
